// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Ribbon_wrapper__aSvBm","content":"Ribbon_content__9m7f4","open":"Ribbon_open__Pbr8N","toggle":"Ribbon_toggle__3MpyJ","toggleIcon":"Ribbon_toggleIcon__stIKV"};